function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#ff4646",
  d: "M24402.576-5499a2.01 2.01 0 0 1-1.912-2.123v-14.565h14.979v14.565a2.008 2.008 0 0 1-1.91 2.123zm8.584-14.436v11.145a.473.473 0 0 0 .473.472.473.473 0 0 0 .473-.472v-11.145a.473.473 0 0 0-.473-.472.473.473 0 0 0-.473.472zm-3.479 0v11.145a.472.472 0 0 0 .473.472.471.471 0 0 0 .471-.472v-11.145a.471.471 0 0 0-.471-.472.472.472 0 0 0-.472.472zm-3.479 0v11.145a.471.471 0 0 0 .471.472.472.472 0 0 0 .473-.472v-11.145a.472.472 0 0 0-.473-.472.471.471 0 0 0-.473.472zm-4.021-3.2a1.179 1.179 0 0 1-1.18-1.179 1.179 1.179 0 0 1 1.18-1.179h15.945a1.178 1.178 0 0 1 1.178 1.179 1.178 1.178 0 0 1-1.178 1.179zm11.863-2.831v-1.356a1.229 1.229 0 0 0-1.273-1.239h-5.236a1.23 1.23 0 0 0-1.273 1.239v1.356h-.943v-1.356a2.174 2.174 0 0 1 2.217-2.182h5.236a2.173 2.173 0 0 1 2.217 2.182v1.356z",
  transform: "translate(-24390 5529.001)"
});

function SvgIconDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDelete);
export default __webpack_public_path__ + "static/media/iconDelete.c7b40ea8.svg";
export { ForwardRef as ReactComponent };